/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventPartyArticleInfo,
    JsonEventPartyArticleInfoFromJSON,
    JsonEventPartyArticleInfoFromJSONTyped,
    JsonEventPartyArticleInfoToJSON,
} from './JsonEventPartyArticleInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonEventPartyArticleInfo
 */
export interface ApiResultOfListOfJsonEventPartyArticleInfo {
    /**
     * 
     * @type {Array<JsonEventPartyArticleInfo>}
     * @memberof ApiResultOfListOfJsonEventPartyArticleInfo
     */
    data?: Array<JsonEventPartyArticleInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventPartyArticleInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonEventPartyArticleInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventPartyArticleInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventPartyArticleInfo
     */
    result?: ApiResultOfListOfJsonEventPartyArticleInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonEventPartyArticleInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonEventPartyArticleInfoFromJSON(json: any): ApiResultOfListOfJsonEventPartyArticleInfo {
    return ApiResultOfListOfJsonEventPartyArticleInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonEventPartyArticleInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonEventPartyArticleInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonEventPartyArticleInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonEventPartyArticleInfoToJSON(value?: ApiResultOfListOfJsonEventPartyArticleInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonEventPartyArticleInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

